// Emergency Report types

export enum EmergencyType {
  Delay = 0,
  Absence = 1,
  Illness = 2,
  Overcrowding = 3,
  EquipmentFailure = 4,
  SafetyIssue = 5,
  StaffShortage = 6,
  CustomerComplaint = 7,
  Other = 99,
}

export enum EmergencyStatus {
  Pending = 0,
  Acknowledged = 1,
  InProgress = 2,
  Resolved = 3,
  Cancelled = 4,
}

export enum EmergencyPriority {
  Low = 0,
  Medium = 1,
  High = 2,
  Critical = 3,
}

export interface EmergencyReport {
  id: number;
  reportedByUserId: number;
  reportedByUserName: string;
  siteId: number;
  siteName: string;
  type: string;
  title: string;
  description: string;
  status: string;
  priority: string;
  relatedShiftId?: number;
  incidentDate?: string;
  responseNotes?: string;
  resolvedByUserId?: number;
  resolvedByUserName?: string;
  resolvedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmergencyReport {
  siteId: number;
  type: EmergencyType;
  title: string;
  description: string;
  priority: EmergencyPriority;
  relatedShiftId?: number;
  incidentDate?: string;
}

export interface UpdateEmergencyReportStatus {
  status: EmergencyStatus;
  responseNotes?: string;
}

export interface EmergencyReportFilter {
  page?: number;
  pageSize?: number;
  siteId?: number;
  type?: EmergencyType;
  status?: EmergencyStatus;
  priority?: EmergencyPriority;
  reportedByUserId?: number;
  fromDate?: string;
  toDate?: string;
}

// Helper functions per le label
export const getEmergencyTypeLabel = (type: string): string => {
  switch (type) {
    case 'Delay':
      return 'Ritardo';
    case 'Absence':
      return 'Assenza';
    case 'Illness':
      return 'Malattia';
    case 'Overcrowding':
      return 'Sovraffollamento';
    case 'EquipmentFailure':
      return 'Guasto attrezzature';
    case 'SafetyIssue':
      return 'Problema di sicurezza';
    case 'StaffShortage':
      return 'Carenza personale';
    case 'CustomerComplaint':
      return 'Reclamo cliente';
    case 'Other':
      return 'Altro';
    default:
      return type;
  }
};

export const getEmergencyStatusLabel = (status: string): string => {
  switch (status) {
    case 'Pending':
      return 'In attesa';
    case 'Acknowledged':
      return 'Presa in carico';
    case 'InProgress':
      return 'In gestione';
    case 'Resolved':
      return 'Risolta';
    case 'Cancelled':
      return 'Annullata';
    default:
      return status;
  }
};

export const getEmergencyPriorityLabel = (priority: string): string => {
  switch (priority) {
    case 'Low':
      return 'Bassa';
    case 'Medium':
      return 'Media';
    case 'High':
      return 'Alta';
    case 'Critical':
      return 'Critica';
    default:
      return priority;
  }
};

export const getEmergencyPriorityColor = (priority: string): string => {
  switch (priority) {
    case 'Low':
      return '#10b981'; // green
    case 'Medium':
      return '#f59e0b'; // amber
    case 'High':
      return '#ef4444'; // red
    case 'Critical':
      return '#991b1b'; // dark red
    default:
      return '#6b7280'; // gray
  }
};

export const getEmergencyStatusColor = (status: string): string => {
  switch (status) {
    case 'Pending':
      return '#f59e0b'; // amber
    case 'Acknowledged':
      return '#3b82f6'; // blue
    case 'InProgress':
      return '#8b5cf6'; // purple
    case 'Resolved':
      return '#10b981'; // green
    case 'Cancelled':
      return '#6b7280'; // gray
    default:
      return '#6b7280'; // gray
  }
};
